export default "__VITE_ASSET__A_t4v4GH__"